<template>
  <div>
    <nav-top @showProfile="showProfile" />
    <div class="container-fluid">
      <div class="row flex-xl-nowrap">
        <main class="p-3 col-12" role="main">
          <slot />
        </main>
      </div>
    </div>
    <div class="custom-version">
      <hr />
      <pre class="text-right text-muted px-4"> v{{ version }} </pre>
    </div>
  </div>
</template>

<script>
import NavTop from '@/layouts/navigation/NavTop.vue'

export default {
  name: 'LayoutDefault',
  components: {
    NavTop
  },
  computed: {
    version() {
      let _version = window.version ? window.version : ''
      return _version
    }
  },
  methods: {
    showProfile() {
      this.$router.push({ name: 'profile' })
    }
  }
}
</script>
<style lang="scss">
.custom-version {
  color: #000;
  font-size: 0.9em;
}
</style>
